import React, {Component} from 'react';
import i18n from "i18next";
import util from "../lib/chart_functions";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {FiMail} from "react-icons/fi";


class PopupForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showPopup: false,
            response: '[]',
            status_code: 200,
            show_notification: false,
            name: '',
            phone: '',
            email: '',
            message: '',
            query: this.props.query,
            object_type: this.props.object_type
        };
    }

    togglePopup = () => {
        this.setState({
            ...this.state,
            display_query: util.my_stringify(this.state.query),
            "showPopup": !this.state.showPopup
        })
    };

    handleChange = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        });
    };

    afterSetStateFinished = () => {
        if (this.state.show_notification) {
            if (this.state.status_code === 200) {
                toast.success('Письмо отправлено!\nПроверьте почту!');
            } else {
                toast.error(`Ошибка ${this.state.status_code}:\n${this.state.response}`);
            }
            this.setState({
                ...this.state,
                show_notification: false
            });
        }
    }

    componentDidUpdate() {
        this.afterSetStateFinished();
    }

    createNewRequest = (e) => {
        e.preventDefault();
        // Добавьте здесь код для отправки данных формы
        const requestOptions = {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                name: this.state.name,
                phone: this.state.phone,
                email: this.state.email,
                message: this.state.message,
                query: this.state.display_query,
                object_type: i18n.t(`${this.state.object_type}_button`)
            })
        };
        fetch(`${process.env.REACT_APP_BACK_END}/request/`, requestOptions)
            .then(response => {
                this.setState({status_code: response.status})
                return response.text()
            })
            .then(data => this.setState({response: data}))
            .then(() => this.setState({show_notification: true}));
        this.setState({
            ...this.state,
            name: '',
            phone: '',
            email: '',
            message: '',
            "showPopup": false
        });
    };

    // console.log(this.state.query)
    render() {
        const {name, phone, email, message, query, showPopup} = this.state;
        return (
            <div>
                <button className="btn btn-outline-dark  w-100" onClick={this.togglePopup}>
                    {i18n.t("make_request")}
                    &ensp;
                    <FiMail/>

                </button>


                {showPopup && (
                    <div className="modal show" style={{display: 'block'}} tabIndex="-1" role="dialog">

                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Форма отправки</h5>
                                    <button type="button" className="btn-close" onClick={this.togglePopup}></button>
                                </div>
                                <div className="modal-body">
                                    <form className="needs-validation">
                                        <div className="mb-3">
                                            <label htmlFor="name"
                                                   className="form-label">{i18n.t("request_name")}</label>
                                            <input type="text"
                                                   className="form-control"
                                                   id="name"
                                                   name="name"
                                                   value={this.state.name}
                                                   onChange={this.handleChange} required/>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="phone"
                                                   className="form-label">{i18n.t("request_phone")}</label>
                                            <input type="phone"
                                                   className="form-control"
                                                   id="phone"
                                                   name="phone"
                                                   value={this.state.phone}
                                                   onChange={this.handleChange}
                                                   required/>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="email"
                                                   className="form-label">{i18n.t("request_email")}</label>
                                            <input type="email"
                                                   className="form-control"
                                                   id="email"
                                                   name="email"
                                                   value={this.state.email}
                                                   onChange={this.handleChange} required/>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="message"
                                                   className="form-label">{i18n.t("request_message")}</label>
                                            <textarea className="form-control"
                                                      id="message"
                                                      name="message"
                                                      value={this.state.message}
                                                      onChange={this.handleChange}></textarea>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="query"
                                                   className="form-label">{i18n.t("request_query")}</label>
                                            <textarea className="form-control"
                                                      id="query" name="query"
                                                      value={this.state.display_query}
                                                      onChange={this.handleChange}
                                                      readOnly></textarea>
                                        </div>
                                        <button type="submit"
                                                className="btn btn-outline-dark"
                                                onClick={(e) => this.createNewRequest(e)}>{i18n.t("make_request")}</button>
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-outline-dark"
                                            onClick={this.togglePopup}>{i18n.t("request_cancel")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )} {
                showPopup
                && <div className="modal-backdrop fade show"></div>
            }

            </div>
        )
            ;
    }
    ;
}


export {PopupForm};